var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 88408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2566",
    d: "M11.5278 2C11.5278 4.34122 11.7756 6.65996 11.7756 9.00772C11.7756 11.9173 11.7756 14.8268 11.7756 17.7364",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2567",
    d: "M2 9.64598C3.64693 9.48128 5.30017 9.18897 6.96245 9.05599C9.16106 8.8801 11.3629 8.7772 13.5637 8.643C15.2053 8.5429 16.8747 8.54388 18.5196 8.584C19.1581 8.59957 19.7591 8.81999 20.4076 8.81999",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.eba7992f8a2f327c7c32002e42aa03da.svg";
export { ForwardRef as ReactComponent };